import React from 'react';
import moment from 'moment';

const RecordPresenceBanner = ({ activeViewers, conflict }) => {
  if ((!activeViewers || activeViewers.length === 0) && !conflict) return null;

  if (conflict) {
    const formattedTime = conflict?.updatedAt
      ? moment(conflict.updatedAt).format('h:mm A')
      : '';
    return (
      <div className="record-presence-banner record-presence-banner--conflict" role="alert">
        <span className="record-presence-banner__icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.138 2.5L1 13.5h14L8.862 2.5a1 1 0 0 0-1.724 0Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
            <path d="M8 7v3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
            <circle cx="8" cy="12" r="0.8" fill="currentColor"/>
          </svg>
        </span>
        <span className="record-presence-banner__text">
          <strong>Conflict Detected:</strong> This record was modified by <strong>{conflict?.userName || 'another user'}</strong>{formattedTime && ` at ${formattedTime}`}. Please exit edit mode without saving and re-open to include the most recent changes before proceeding.
        </span>
      </div>
    );
  }

  const viewerNames = (activeViewers || [])
    .map(v => v?.userName || 'Unknown User')
    .join(', ');

  return (
    <div className="record-presence-banner record-presence-banner--viewers" role="status">
      <span className="record-presence-banner__icon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
          <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.4"/>
        </svg>
      </span>
      <span className="record-presence-banner__text">
        <strong>{viewerNames}</strong> is also viewing/editing this record
      </span>
    </div>
  );
};

export default RecordPresenceBanner;
